// extracted by mini-css-extract-plugin
export var containerClassMenu = "Footer-module--containerClassMenu--f618e";
export var iconStyle = "Footer-module--iconStyle--750a0";